import { RootState } from '../../store/root-state';

export const getNavigationState = (state: RootState) => state.navigation.navigation;
